var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: {
      'bg-secondary section-with-bg': _vm.hasBackground,
      'section-logos': _vm.hasInnerBackground
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "pl-0 py-1 d-flex justify-content-between align-items-center",
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "section-slider-head"
  }, [_vm.onlyTitle ? _c('h2', {
    staticClass: "best-picks bestpicks-h2"
  }, [_vm._v(" " + _vm._s(_vm.title || _vm.$t("productStore.bestPicks")) + " ")]) : _vm._e(), _vm.showTitle ? _c('h3', {
    staticClass: "heading"
  }, [_vm.showBackArrow ? _c('router-link', {
    attrs: {
      "button": "",
      "to": "/"
    }
  }, [_c('b-icon', {
    staticClass: "mr-2",
    attrs: {
      "icon": "arrow-left-short",
      "variant": "black",
      "scale": "1.5"
    }
  })], 1) : _vm._e(), _vm._v(_vm._s(_vm.subTitle) + " ")], 1) : _vm._e()]), !_vm.loading && _vm.list.length === 0 ? _c('div', {
    staticClass: "text-center no-item"
  }, [_vm._v(" " + _vm._s(_vm.$t("productStore.noItmes")) + " ")]) : _vm._e(), _c('router-link', {
    staticClass: "view-more-button",
    style: {
      border: this.theme && this.theme.primarycolor && this.theme.primarycolor.color
    },
    attrs: {
      "to": _vm.viewMorePage
    }
  }, [_vm.hasButton ? _c('button', {
    staticClass: "view-more-text",
    style: {
      color: this.theme && this.theme.primarycolor && this.theme.primarycolor.gradientColors[0].color,
      backgroundColor: this.theme && this.theme.primarycolor && this.theme.primarycolor.color
    }
  }, [_vm._v(" View more "), _c('b-icon-arrow-right')], 1) : _vm._e()])], 1)], 1), _vm.withSlider ? _c('v-slide-group', {
    ref: "slideGroup",
    attrs: {
      "show-arrows": "always"
    }
  }, [_vm.loading ? _vm._l(_vm.maxItems, function (n) {
    return _c('v-slide-item', {
      key: 'skeleton-slide-' + n
    }, [_c('b-skeleton', {
      staticClass: "mr-2",
      attrs: {
        "type": "card",
        "width": "200px",
        "height": "250px"
      }
    })], 1);
  }) : _vm._l(_vm.list, function (data, i) {
    return _c('v-slide-item', {
      key: i
    }, [_vm._t("default", null, {
      "listItem": data
    })], 2);
  })], 2) : _vm._e(), _vm.withoutSlider ? _c('v-slide-item', [_vm.loading ? _c('b-row', _vm._l(_vm.maxItems, function (n) {
    return _c('b-col', {
      key: 'skeleton-' + n,
      staticClass: "slideItem",
      attrs: {
        "md": "3",
        "sm": "6",
        "xs": "12"
      }
    }, [_c('b-skeleton', {
      staticClass: "mb-3",
      attrs: {
        "width": "100%",
        "height": "200px",
        "animation": "wave"
      }
    })], 1);
  }), 1) : !_vm.loading && _vm.list.length ? _c('b-row', _vm._l(_vm.list.slice(0, _vm.maxItems), function (data, i) {
    return _c('b-col', {
      key: i,
      staticClass: "slideItem",
      attrs: {
        "md": "3",
        "sm": "6",
        "xs": "12"
      }
    }, [_vm._t("default", null, {
      "listItem": data
    })], 2);
  }), 1) : _c('div', {
    staticClass: "text-center no-item"
  }, [_vm._v(" " + _vm._s(_vm.$t("productStore.noItmes")) + " ")])], 1) : _vm._e()], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }